import { render, staticRenderFns } from "./AppTransitionGroup.vue?vue&type=template&id=2198b690&scoped=true"
import script from "./AppTransitionGroup.vue?vue&type=script&lang=js"
export * from "./AppTransitionGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2198b690",
  null
  
)

export default component.exports